import { storeUserIdPhyIdModel } from "./storeuseridphyidmodel";


 
export class storeUserIdPhyIdAction {
    static readonly type = '[USerIDPhyID] USerIDPhyID';

    constructor(public payload: storeUserIdPhyIdModel) {
    }
}
export class storePhyIdAction {
    static readonly type = '[PhyID] PhyID';

    constructor(public payload: number) {

    }
}
export class storePrescriberIdAction {
    static readonly type = '[PrescriberId] PrescriberId';

    constructor(public payload: {prescriberId:number,prescriberUserInternalId:number}) {

    }
}

export class storeLocationIdAction {
    static readonly type = '[LocationID] LocationID';

    constructor(public payload: number) {

    }
}
export class StorePhysicianUserIdAction {
    static readonly type = '[PhysicianID] PhysicianID';

    constructor(public payload: number) {}
}
export class ClearPhysicianUserIdAction {
    static readonly type = '[ClearUserIdPhysicianId] ClearUserIdPhysicianId';

    constructor() { }
}
/*export class StoreNursingStationIds {
    static readonly type='[NurseStationIds] NurseStationIds';

    constructor(public payload: string) {}
}*/
 
// export class storeroutingAction {
//     static readonly type = '[routing] routing';

//     constructor(public payload: string) {

//     }
// }